// Capture UTMs from URL params to gform hidden fields

import getParam from '../../util/getURLParam.js'
import cookies from '../../util/cookies.js'
import GravityForms from './component.js'

class utm extends GravityForms {
  constructor() {
    super()
    let form = this.form
    if (form) {
      let utmCookie = cookies.getCookie('sm_utmsource')
      let utmCampaignCookie = cookies.getCookie('sm_utmcampaign')
      let utmMediumCookie = cookies.getCookie('sm_utmmedium')
      let utmOfferCookie = cookies.getCookie('sm_utmoffer')

      let utmSource = getParam('utm_source')
      let utmMedium = getParam('utm_medium')
      let utmCampaign = getParam('utm_campaign')
      let utmOffer = getParam('utm_offer')

      let fieldSource = form.querySelector('[id="uploadSourceType"]')
      console.log('fieldSource:::', fieldSource)
      let fieldCampaign = form.querySelector('[id="oPSUTMCampaign"]')
      let fieldMedium = form.querySelector('[id="oPSUTMMedium"]')
      let fieldOffer = form.querySelector('[id="oPSUTMOffer"]')
      let fieldDate = form.querySelector('[id="oPSUTMDate"]')
      var date = new Date()
      let month = date.getMonth() + 1
      let presentDate = date.getDate() + '-' + month + '-' + date.getFullYear()

      // set presentDate to sm_utmDate cookie if the utm_source is available in url.
      // If not use old cookie value.
      if (fieldDate) {
        if (utmSource !== null) {
          fieldDate.value = presentDate
        } else {
          let utmDateCookie = cookies.getCookie('sm_utmdate')
          fieldDate.value = utmDateCookie
        }
      }

      if (fieldSource) {
        if (utmSource !== null) { // If utms available then set utm values from url into hidden form field
          fieldSource.value = utmSource
        } else if (utmCookie !== '') { // If utms doesn't available then set cookie value
          fieldSource.value = utmCookie
        }
      }

      if (fieldCampaign) {
        if (utmCampaign !== null) {
          fieldCampaign.value = utmCampaign
        } else if (utmCampaignCookie !== '') {
          fieldCampaign.value = utmCampaignCookie
        }
      }

      if (fieldMedium) {
        if (utmMedium !== null) {
          fieldMedium.value = utmMedium
        } else if (utmMediumCookie !== '') {
          fieldMedium.value = utmMediumCookie
        }
      }

      if (fieldOffer) {
        if (utmOffer !== null) {
          fieldOffer.value = utmOffer
        } else if (utmOfferCookie !== '') {
          fieldOffer.value = utmOfferCookie
        }
      }
    }
  }
}

new utm()



// WEBPACK FOOTER //
// ./scripts/routes/gravity-forms/utm.js